"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLabel = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./HorizontalLabel.module.css"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var HorizontalLabel = (function (_super) {
    __extends(HorizontalLabel, _super);
    function HorizontalLabel(props) {
        var _this = _super.call(this, props) || this;
        _this.helpVisible = false;
        return _this;
    }
    HorizontalLabel.prototype.render = function () {
        var _a = this.props, error = _a.error, help = _a.help, text = _a.text, required = _a.required, htmlFor = _a.htmlFor, className = _a.className;
        return (React.createElement(React.Fragment, null,
            React.createElement("label", { className: className ? className : styles.root, htmlFor: htmlFor },
                text,
                required && React.createElement("span", null, "*"),
                help && React.createElement("small", { style: { display: "block" } }, help)),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    __decorate([
        mobx_1.observable
    ], HorizontalLabel.prototype, "helpVisible", void 0);
    HorizontalLabel = __decorate([
        mobx_react_1.observer
    ], HorizontalLabel);
    return HorizontalLabel;
}(react_1.Component));
exports.HorizontalLabel = HorizontalLabel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSG9yaXpvbnRhbExhYmVsLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9Ib3Jpem9udGFsTGFiZWwvSG9yaXpvbnRhbExhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5QiwrQkFBK0I7QUFDL0IsbUVBQXNEO0FBQ3RELHlDQUFtQztBQUNuQyw2QkFBK0I7QUFZL0I7SUFBcUMsbUNBQThCO0lBSS9ELHlCQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FDZjtRQUpPLGlCQUFXLEdBQUcsS0FBSyxDQUFBOztJQUkzQixDQUFDO0lBQ00sZ0NBQU0sR0FBYjtRQUNVLElBQUEsS0FBb0QsSUFBSSxDQUFDLEtBQUssRUFBN0QsS0FBSyxXQUFBLEVBQUUsSUFBSSxVQUFBLEVBQUUsSUFBSSxVQUFBLEVBQUUsUUFBUSxjQUFBLEVBQUUsT0FBTyxhQUFBLEVBQUUsU0FBUyxlQUFjLENBQUE7UUFFcEUsT0FBTyxDQUNILG9CQUFDLEtBQUssQ0FBQyxRQUFRO1lBQ1gsK0JBQU8sU0FBUyxFQUFFLFNBQVMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPO2dCQUNsRSxJQUFJO2dCQUNKLFFBQVEsSUFBSSxzQ0FBYztnQkFDMUIsSUFBSSxJQUFJLCtCQUFPLEtBQUssRUFBRSxFQUFDLE9BQU8sRUFBRSxPQUFPLEVBQUMsSUFBRyxJQUFJLENBQVMsQ0FDckQ7WUFDUCxLQUFLLElBQUksMkJBQUcsU0FBUyxFQUFFLE1BQU0sQ0FBQyxLQUFLO2dCQUFHLEtBQUs7b0JBQU0sQ0FDckMsQ0FDcEIsQ0FBQTtJQUNMLENBQUM7SUFsQkQ7UUFEQyxpQkFBVTt3REFDZ0I7SUFGbEIsZUFBZTtRQUQzQixxQkFBUTtPQUNJLGVBQWUsQ0FxQjNCO0lBQUQsc0JBQUM7Q0FBQSxBQXJCRCxDQUFxQyxpQkFBUyxHQXFCN0M7QUFyQlksMENBQWUifQ==